import React, {Component} from 'react';
import PropTypes from 'prop-types';
import cIf from 'classnames';
import TranslatorManager from 'ts-translate-js';

const tr = TranslatorManager.boundTR;

export class WaitSpinner extends Component {
    render() {
        return (
            <div className={cIf(this.props.integ)}>
                <div className="wait-spinner">
                    <ul>
                        <li>
                            <i className={
                            cIf(["fas fa-spinner fa-pulse fa-fw spinner",
                                 { 
                                     "fa-lg": (this.props.size === "xs"),
                                     "fa-2x": (this.props.size === "sm" || this.props.size == null),
                                     "fa-3x": (this.props.size === "md"),
                                     "fa-4x": (this.props.size === "lg"),
                                     "fa-5x": (this.props.size === "xl")
                                 }
                            ]
                            )}>
                            </i>
                        </li>
                        {this.props.children != null
                        ? <li>{this.props.children}</li>
                        : null}
                    </ul>
                </div>
            </div>
        );
    }
}
WaitSpinner.propTypes = {
    size: PropTypes.string,
    integ: PropTypes.string
};


export class PleaseWaitSpinner extends Component {
    render() {
        return (
            <WaitSpinner {...this.props}>
                <span className={cIf("title", (this.props.size != null? this.props.size : "") )} >{tr("general.pleasewait")}</span>
            </WaitSpinner>
        );
    }
}
PleaseWaitSpinner.propTypes = {
    size: PropTypes.string,
    integ: PropTypes.string
};

export class OverlayWaitSpinner extends Component {
    render() {
        return (
            <div className="overlay"><WaitSpinner {...this.props}></WaitSpinner></div>
        );
    }
}

